import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
const { EleResize } = require('@/assets/js/eresize.js');
let FailureInfo = class FailureInfo extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        this.allfailureInfoStat = {
            deviceCountStat: [],
            deviceSortStat: [],
            deviceCountFormonthStat: [],
            deviceStatusStat: [],
        };
        this.arrayEvents = [];
        this.search = {
            loading: false,
            sysStatus: '',
            isTemp: '',
            startDate: '',
            endDate: '',
            queryYear: '',
            time: [(new Date()).getFullYear() + '-01' + '-01', (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),],
            conditions: 'MONTH',
            menu: {
                date: false,
                dateType: 'MONTH',
                type: 'month',
                startDate: false,
                endDate: false,
            },
        };
        this.lastMonth = ['01', '03', '05', '07', '08', '10', '12'];
        this.nowYear = String((new Date()).getFullYear());
        const that = this;
    }
    async mounted() {
        const that = this;
        // this.search.conditions = 'YEAR'
        // this.nowYear = String((new Date()).getFullYear())
        await that.fetchMalfunctionCatalog();
        if (!that.search.queryYear) {
            that.search.queryYear = (that.malfunctionYears.length ? Math.max(...that.malfunctionYears) : new Date().getFullYear()).toString();
        }
        this.getLayoutData();
    }
    async getLayoutData() {
        const that = this;
        const flag = that.search['conditions'] == 'YEAR';
        const params = {
            startDate: that.search.queryYear ? that.search.queryYear + '-01-01' : '',
            endDate: that.search.queryYear ? that.search.queryYear + '-12-31' : '',
            dataType: '',
        };
        try {
            const res = await that.axios.get('/api/report/malfunction/stat', { params: params });
            if (!res.data || !res.data.result || (typeof res.data.result !== 'object')) {
                this.snackbar.error(`查询数据出错：${res.data.result || ''}`);
                return;
            }
            const allData = res.data.result;
            // 调用当前图表
            this.deviceFailureMonthChart(allData.allFailureCountRes);
            this.deviceFailureCategory(allData.deviceFailureSortRes);
            // 设备每月故障数量
            this.initDeviceMonthCount(allData.deviceFailureCountRes);
            this.initDeviceAllData(allData.deviceFailureStatusRes);
        }
        catch (error) {
            this.snackbar.error(`查询数据出错：${error || ''}`);
        }
    }
    functionEvents(date) {
        const that = this;
        let list;
        list = this.arrayEvents.map((r) => {
            const i = new Date(r);
            return that.search.menu.dateType == 'MONTH' ? i.format('YYYY-MM-dd') : r;
        });
        return list.includes(date);
    }
    changeDate(e) {
        const that = this;
        if (e) {
            that.search.conditions = e;
            if (e == 'YEAR') {
                // this.setElement()
                return that.search.menu.dateType = 'YEAR';
            }
            that.search.menu.dateType = e;
            that.search.menu.type = e.toLowerCase();
        }
    }
    timeInput() {
        const that = this;
        if (that.search.time.length >= 2 && that.search.time[0] !== '' && that.search.time[1] !== '') {
            this.getLayoutData();
            that.search.menu.date = false;
        }
    }
    mousedown(year) {
        const that = this;
        if (that.search.menu.dateType == 'YEAR') {
            that.search.time[0] = year + '-01' + '-01';
            that.search.time[1] = year + '-12' + '-31';
            this.getLayoutData();
            that.search.menu.date = false;
        }
    }
    // 限制查询日期(结束时间不能小于开始时间)
    auditAllowDate(val) {
        const that = this;
        const dstDate = new Date(val).getTime();
        return that.search.time.length === 1 ? dstDate >= new Date(that.search.time[0]).getTime() : true;
    }
    setElement() {
        const that = this;
        const time = that.search.menu.dateType;
        const showed = true; // that.tableDate['items'].length > 0
    }
    // 设备故障状态
    initDeviceAllData(resData) {
        const that = this;
        if (resData.result && resData.result.length) {
            const groupedItems = resData.result.reduce((accumulator, currentItem) => {
                // 根据某个字段值将对象分组
                const groupKey = currentItem.modeCode;
                if (!accumulator[groupKey]) {
                    accumulator[groupKey] = currentItem;
                }
                return accumulator;
            }, {});
            // 将去重后的结果转换为数组
            const uniqueItems = Object.values(groupedItems);
            that.allfailureInfoStat.deviceStatusStat = uniqueItems || [];
        }
        else {
            that.allfailureInfoStat.deviceStatusStat = [];
            return;
        }
        // let deviceData = { "checkNum": 0, "stayNum": 0, "handleNum": 0, "temporarilyNum": 0, "completeNum": 0 }
        that.allfailureInfoStat.deviceStatusStat.forEach((c) => {
            const rowData = c.modeCode;
            const checkData = resData.result.filter((it) => it.modeCode == rowData && it.status == '待验证'); // 待验证
            const stayData = resData.result.filter((it) => it.modeCode == rowData && it.status == '待观察'); // 待观察
            const handleData = resData.result.filter((it) => it.modeCode == rowData && it.status == '待处理'); // 待处理
            const temporarilyData = resData.result.filter((it) => it.modeCode == rowData && it.status == '暂处理'); // 暂处理
            const completeData = resData.result.filter((it) => it.modeCode == rowData && it.status == '已完成'); // 已完成
            const deviceData = {
                checkNum: checkData && checkData.length ? checkData[0].times || 0 : 0,
                stayNum: stayData && stayData.length ? stayData[0].times || 0 : 0,
                handleNum: handleData && handleData.length ? handleData[0].times || 0 : 0,
                temporarilyNum: temporarilyData && temporarilyData.length ? temporarilyData[0].times || 0 : 0,
                completeNum: completeData && completeData.length ? completeData[0].times || 0 : 0,
            };
            c.deviceStatusData = deviceData || {};
        });
        // 只保留 modeCode 字段并去重
        // var deviceModeList = Array.from(new Set(resData.result.map((item: any) => item.modeCode)));
        that.$nextTick(async () => {
            for (let i = 0; i < that.allfailureInfoStat.deviceStatusStat.length; i++) {
                const rows = that.allfailureInfoStat.deviceStatusStat[i];
                initEcharts(`deviceStatus${rows.modeCode}`, rows.deviceStatusData);
            }
        });
        function initEcharts(element, data) {
            const eles = that.$refs[element];
            if (eles) {
                const echartsDom = (eles && eles[0]) || eles;
                const charts = that.$echarts.init(echartsDom);
                if (!charts) {
                    return;
                }
                charts.showLoading();
                const optionData = {
                    color: ['#5470C6', '#EE6666', '#FAC858', '#73C0DE', '#4CAF50'],
                    tooltip: {
                        trigger: 'item'
                    },
                    // title: {
                    //   text: 'Referer of a Website',
                    //   subtext: 'Fake Data',
                    //   left: 'center'
                    // },
                    legend: {
                        orient: 'vertical',
                        left: 'right'
                    },
                    series: [
                        {
                            name: '故障状态',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            itemStyle: {
                                borderRadius: 10,
                                borderColor: '#fff',
                                borderWidth: 2
                            },
                            label: {
                                show: false,
                                position: 'right'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    top: '5%',
                                    fontSize: 20,
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: data.stayNum, name: '待观察' },
                                { value: data.handleNum, name: '待处理' },
                                { value: data.temporarilyNum, name: '暂处理' },
                                { value: data.checkNum, name: '待验证' },
                                { value: data.completeNum, name: '已完成' }
                            ]
                        }
                    ]
                };
                charts.setOption(optionData);
                charts.hideLoading();
                EleResize.on(echartsDom, () => charts.resize());
            }
        }
    }
    /** 单个设备每月故障数量 */
    initDeviceMonthCount(resData) {
        const that = this;
        if (!resData.result || !resData.result.length) {
            that.allfailureInfoStat.deviceCountFormonthStat = [];
            return;
        }
        const groupedItems = resData.result.reduce((accumulator, currentItem) => {
            // 根据某个字段值将对象分组
            const groupKey = currentItem.modeCode;
            if (!accumulator[groupKey]) {
                accumulator[groupKey] = currentItem;
            }
            return accumulator;
        }, {});
        // 将去重后的结果转换为数组
        const uniqueItems = Object.values(groupedItems);
        that.allfailureInfoStat.deviceCountFormonthStat = uniqueItems || [];
        // 只保留 modeCode 字段并去重
        const deviceModeList = Array.from(new Set(resData.result.map((item) => item.modeCode)));
        const xData = [];
        for (let i = 1; i < 13; i++) {
            xData.push(i + '月');
        }
        that.$nextTick(async () => {
            for (let i = 0; i < deviceModeList.length; i++) {
                const data = [];
                for (let index = 1; index < 13; index++) {
                    const allTimes = resData.result.filter((it) => parseInt(it.formattMonth) == index && it.modeCode == deviceModeList[i]);
                    data.push(allTimes.length ? allTimes[0].times || 0 : 0);
                }
                initEcharts(`deviceCharts${deviceModeList[i]}`, data, xData);
            }
        });
        function initEcharts(element, data, xData) {
            const eles = that.$refs[element];
            if (eles) {
                const echartsDom = (eles && eles[0]) || eles;
                const charts = that.$echarts.init(echartsDom);
                if (!charts) {
                    return;
                }
                charts.showLoading();
                const option = {
                    // title: {
                    //   text: '台式安瓿设备----AL-AB-02'
                    // },
                    color: ['#3F51B5'],
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {},
                    toolbox: {
                        show: true,
                        feature: {
                            // dataZoom: {
                            //   yAxisIndex: 'none'
                            // },
                            dataView: { readOnly: false },
                            magicType: { type: ['line', 'bar'] },
                            restore: {},
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    series: [
                        {
                            name: '',
                            type: 'line',
                            data: data,
                            markPoint: {
                                data: [
                                    { type: 'max', name: 'Max' },
                                    { type: 'min', name: 'Min' }
                                ],
                            },
                        },
                    ]
                };
                charts.setOption(option);
                charts.hideLoading();
                EleResize.on(echartsDom, () => charts.resize());
            }
        }
    }
    // 设备每月故障数量
    deviceFailureMonthChart(data) {
        const that = this;
        const dataList = [{ flowName: '1月', total: 0 }, { flowName: '2月', total: 0 }, { flowName: '3月', total: 0 }, { flowName: '4月', total: 0 }, { flowName: '5月', total: 0 }, { flowName: '6月', total: 0 }, { flowName: '7月', total: 0 }, { flowName: '8月', total: 0 }, { flowName: '9月', total: 0 }, { flowName: '10月', total: 0 }, { flowName: '11月', total: 0 }, { flowName: '12月', total: 0 }];
        // 初始化图表，this.$refs.deviceFailure_total_months获取到图表容器
        if (data.result && data.result.length) {
            dataList.forEach((c) => {
                const allTotal = data.result.filter((t) => parseInt(t.formattMonth) === parseInt(c.flowName));
                c.total = allTotal.length ? allTotal[0].times : 0;
            });
        }
        const myChart = that.$echarts.init(that.$refs.deviceFailure_total_months);
        myChart.showLoading();
        const option = {
            color: ['#43a7e3'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            xAxis: {
                type: 'category',
                data: dataList.map(e => e.flowName)
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    data: dataList.map(e => e.total),
                    type: 'bar',
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(180, 180, 180, 0.2)'
                    },
                    itemStyle: {
                        normal: {
                            label: {
                                show: true,
                                position: 'top',
                                textStyle: {
                                    fontSize: 16,
                                    color: 'rgb(115,192,222)'
                                }
                            }
                        }
                    }
                }
            ]
        };
        myChart.setOption(option);
        myChart.hideLoading();
        EleResize.on(that.$refs.deviceFailure_total_months, () => myChart.resize());
    }
    // 设备故障分类统计
    deviceFailureCategory(data) {
        const that = this;
        that.$nextTick(() => {
            const eles = that.$refs.deviceFailure_category;
            if (eles) {
                const echartsDom = (eles && eles[0]) || eles;
                const charts = that.$echarts.init(echartsDom);
                if (!charts) {
                    return;
                }
                charts.showLoading();
                const xAxisData = [];
                const initialData = []; // 初始故障
                const accidentalData = []; // 偶然故障
                const lossData = []; // 损耗故障
                for (let i = 1; i < 13; i++) {
                    xAxisData.push(i + '月');
                    initialData.push(0);
                    accidentalData.push(0);
                    lossData.push(0);
                }
                if (data.result && data.result.length) {
                    const resData = data.result || [];
                    const initialList = resData.filter((it) => it.failureStage === '初始故障');
                    const accidentalList = resData.filter((it) => it.failureStage === '偶然故障');
                    const lossList = resData.filter((it) => it.failureStage === '损耗故障');
                    for (let i = 1; i < 13; i++) {
                        if (initialList.length && initialList.find((c) => parseInt(c.formattMonth) == i)) {
                            initialData[i - 1] = initialList.find((c) => parseInt(c.formattMonth) == i)['times'];
                        }
                        if (accidentalList.length && accidentalList.find((c) => parseInt(c.formattMonth) == i)) {
                            accidentalData[i - 1] = accidentalList.find((c) => parseInt(c.formattMonth) == i)['times'];
                        }
                        if (lossList.length && lossList.find((c) => parseInt(c.formattMonth) == i)) {
                            lossData[i - 1] = lossList.find((c) => parseInt(c.formattMonth) == i)['times'];
                        }
                    }
                }
                const emphasisStyle = {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0,0,0,0.3)',
                    }
                };
                const option = {
                    color: ['#5470C6', '#73C0DE', '#FAC858'],
                    legend: {
                        data: ['初始故障', '偶然故障', '损耗故障'],
                        left: '10%'
                    },
                    // brush: {
                    //   toolbox: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
                    //   xAxisIndex: 0
                    // },
                    toolbox: {
                        feature: {
                            magicType: {
                                type: ['stack']
                            },
                            dataView: {}
                        }
                    },
                    tooltip: {},
                    xAxis: {
                        data: xAxisData,
                        name: '月份',
                        axisLine: { onZero: true },
                        splitLine: { show: false },
                        splitArea: { show: false }
                    },
                    yAxis: {},
                    grid: {
                        bottom: 30
                    },
                    series: [
                        {
                            name: '初始故障',
                            type: 'bar',
                            stack: 'one',
                            emphasis: emphasisStyle,
                            data: initialData
                        },
                        {
                            name: '偶然故障',
                            type: 'bar',
                            stack: 'one',
                            emphasis: emphasisStyle,
                            data: accidentalData
                        },
                        {
                            name: '损耗故障',
                            type: 'bar',
                            stack: 'one',
                            emphasis: emphasisStyle,
                            data: lossData
                        }
                    ]
                };
                charts.setOption(option);
                charts.hideLoading();
                EleResize.on(that.$refs.deviceFailure_category, () => charts.resize());
            }
        });
    }
};
__decorate([
    Getter
], FailureInfo.prototype, "userInfo", void 0);
__decorate([
    Getter
], FailureInfo.prototype, "malfunctionYears", void 0);
__decorate([
    Action
], FailureInfo.prototype, "fetchMalfunctionCatalog", void 0);
FailureInfo = __decorate([
    Component({
        name: 'FailureInfo',
        components: {
            BcSnackbar,
        }
    })
], FailureInfo);
export default FailureInfo;
